/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Testimonials_HeadingInputs */

const en_testimonials_heading = /** @type {(inputs: Testimonials_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What students & researchers think`)
};

const es_testimonials_heading = /** @type {(inputs: Testimonials_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo que piensan estudiantes e investigadores`)
};

/**
* | output |
* | --- |
* | "What students & researchers think" |
*
* @param {Testimonials_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const testimonials_heading = /** @type {((inputs?: Testimonials_HeadingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Testimonials_HeadingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_testimonials_heading(inputs)
	return en_testimonials_heading(inputs)
});